import type { RuleDefinition } from '../domain/types';
import { finding, isCellBlank } from './helpers';

export const BQ003: RuleDefinition = {
  id: 'BQ003',
  name: '项目编码缺失',
  description: '提醒明细行缺少项目编码；并非所有清单类型都强制具有编码。',
  defaultSeverity: 'warning',
  enabled: true,
  applicableFields: ['code'],
  message: '明细行的项目编码为空，请结合清单类型人工确认。',
  suggestion: '如该类清单应有编码，请回到原文件补充；否则可保留并记录复核说明。',
  check: ({ detailRows }) =>
    detailRows.filter((row) => isCellBlank(row, 'code')).map((row) => finding(row, 'code')),
};
